import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Whitepapers1() {
  const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};


const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};


const handleContactSubmit = async (e) => {
  e.preventDefault();
 
  setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;


  // Basic validation
  if (!fullname || !email || !message || !company || !phone ) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
     try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
        {showSuccessModal && (
          <motion.div
            className="modal-overlay show"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              className="modal show"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                width: "400px",
                textAlign: "center",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                Message Sent!
              </h2>
              <p>Thank you for contacting us. We will get back to you shortly.</p>
              <button className="vc rg lk gh ml il hi gi _l"
                onClick={() => setShowSuccessModal(false)}
               
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
            
            <div className="container">
               <div className="left">
          <img src="../images/wh1.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm mk nb gb">
               From Signals to Sales: How AI-Powered Intent Data is Redefining B2B Lead Generation in 2025
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb jutfy">
               <li>
                  <span className="rc kk wm">Published On: </span> Oct 26, 2025
                   
                </li>
                <li>
                   <span className="rc kk wm"><b>Published by:</b></span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
             <p className="mk3 ij">
                Turning behavioral intelligence into predictive revenue growth
              </p>
             
              <p className="mb bgimh">
               Executive Summary 
              </p>
 <p className="jutfy">
  B2B buying has become digital, data-driven, and intent-led. Traditional lead generation is being replaced by AI systems that decode buyer signals across every touchpoint. This whitepaper explores how AI-powered intent data is transforming how companies identify, engage, and convert high-value prospects—and how forward-thinking organizations can stay ahead in 2025.
              </p>
               <p className="mb bgimh">
              The Evolution of B2B Lead Generation 
              </p>
 <p className="jutfy">
  Modern B2B buyers complete nearly 80% of their research before contacting sales. With cookie deprecation, fragmented buyer journeys, and information overload, AI-powered intent data helps identify real-time buying signals to prioritize outreach


              </p>

               <p className="mb bgimh">
                What Is Intent Data—and Why It Matters
              </p>
 <p className="jutfy">
  Intent data captures behavioral cues that indicate active research or purchase readiness. AI models aggregate and interpret these signals—revealing who is in-market, what they care about, and when to engage
              </p>
              <p className="mb bgimh">
             How AI Transforms Intent Data into Action
              </p>

 <p className="jutfy">
  AI unifies multiple signal sources, applies predictive modeling, and continuously learns from outcomes. The result is precise targeting, adaptive campaigns, and higher ROI.
              </p>


              <p className="mb bgimh">
             2. Execute: Build a Coordinated ABM Engine
              </p>

                <p className="jutfy">
                    Execution is where strategy meets action. A successful ABM campaign blends personalized content, multi-channel outreach, and sales follow-ups — all timed and tailored to specific accounts.
              </p>
                <p className="mb bgimh">
            Benefits of AI-Powered Intent Data
              </p>
              <ul className="jutfy">
                <li>• Precision targeting </li>
 <li>• Sales efficiency </li>
 <li>• Higher ROI </li>
 <li>• Personalized engagement </li>
 <li>• Shared intelligence between marketing and sales
</li>
              </ul>

               <p className="mb bgimh">
         Implementation Roadmap
              </p>
               <ul className="jutfy">
                <li>1. Discovery – Audit current data and signal sources </li>
 <li>2. Integration – Connect CRM, MAP, and analytics </li>
 <li>3. Activation – Launch AI-informed ABM and outreach </li>
 <li>4. Optimization – Use feedback loops to refine model

</li>
              </ul>

              <p className="mb bgimh">
               How Pinakinedge Media Helps
              </p>
 <p className="jutfy">
At Pinakinedge Media, we help B2B organizations transform buyer signals into qualified pipeline through AI-powered intent intelligence. Our approach integrates your data sources, applies predictive AI scoring, and activates personalized campaigns to drive faster revenue growth
<br/>
We offer:               </p>
              <ul className="jutfy">
                <li>Unified data integration </li>
<li>AI-driven predictive scoring </li>
<li>ABM personalization and automation  </li>
<li>• Privacy-first compliance With Pinakinedge Media, you don’t just generate leads—you predict opportunity</li>

              </ul>

              
              <p className="jutfy">Connect with Pinakinedge Media and discover how we help businesses turn content into real growth opportunities.</p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
              <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("White Paper1: From Signals to Sales: How AI-Powered Intent Data is Redefining B2B Lead Generation in 2025");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Whitepapers1;
